import script from "./form5View.vue?vue&type=script&setup=true&lang=js"
export * from "./form5View.vue?vue&type=script&setup=true&lang=js"

import "./form5View.vue?vue&type=style&index=0&id=6553bca5&lang=css"

const __exports__ = script;

export default __exports__